export default style => ({
  normal: {
    marginTop: 152,
    minHeight: "calc(100vh - 310px)"
  },
  panel: {
    backgroundColor: "#f6f6f6",
    height: "100vh"
  },
  web: {
    backgroundColor: "#fff"
  }
});